import React from "react"
import CourseCardBadge from "../course-card-badge/course-card-badge.component"
import dataLayerHelper from "../../helpers/datalayer.helper"

import {
  CardContainer,
  CardTitle,
  ImgContainer,
  ContentContainer,
  Excerpt,
  AuthorsContainer,
  AuthorCard,
  AuthorName,
  AuthorImage,
  ButtonsContainer,
  BtnLink,
  TimeDetails,
} from "./general-card.styles"

const GeneralCard = ({
  authors,
  title,
  badge,
  url,
  image,
  excerpt,
  buttonText,
  coursePromoUrl,
  timeDetails,
  gtmDataLayer,
  cardType,
}) => {
  const isInternal = /^\//gi.test(url) // match string starting with slash return boolean value (bonus card )
  const target = isInternal ? "_self" : "_blank"

  const generateCourseButtons = () => {
    return (
      <ButtonsContainer>
        <BtnLink
          square
          secondary
          target="_blank"
          url={coursePromoUrl}
          small
          onClick={() => {
            dataLayerHelper({
              event: gtmDataLayer.buttonOne,
              label: title,
            })
          }}
        >
          Start Learning
        </BtnLink>

        <BtnLink
          onClick={() => dataLayerHelper({ event: gtmDataLayer.btnTwo })}
          url={url}
          internal
          small
          secondary
          square
          ghost
        >
          Course Details
        </BtnLink>
      </ButtonsContainer>
    )
  }

  const generateBonusButtons = () => {
    return (
      <ButtonsContainer>
        <BtnLink
          secondary
          small
          square
          ghost
          url={url}
          target={target}
          internal={isInternal}
        >
          {buttonText ? buttonText : "View Details"}
        </BtnLink>
      </ButtonsContainer>
    )
  }
  // for the Sprints Course Card
  const renderAuthorLink = (slug) => {
    return slug === "ztm-instructor-team"
      ? "/about/"
      : `/about/instructor/${slug}`
  }


  return (
    <CardContainer>
      {badge ? <CourseCardBadge badge={badge} /> : null}

      <a
        onClick={() =>
          dataLayerHelper({ event: gtmDataLayer.cardImage, label: title })
        }
        href={url}
        tabIndex="-1"
      >
        <ImgContainer image={image.gatsbyImageData} alt={title} />
      </a>

      <ContentContainer cardType={cardType}>

        <CardTitle
          cardType={cardType}
          onClick={() => dataLayerHelper({ event: gtmDataLayer.cardTitle })}
          href={url}
          tabIndex="-1"
        >
          <p>{title}</p>
          <TimeDetails cardType={cardType}>{timeDetails}</TimeDetails>
          <Excerpt cardType={cardType}>{excerpt}</Excerpt>
        </CardTitle>
        <AuthorsContainer>
          {authors && authors.length > 1 ? (
            <>
              <div style={{ display: "flex" }}>
                {authors.map(({ profileImage: { file: { url } } }, index) => (
                  <AuthorImage key={url} index={index} img={`${url}?h=40&w=40`} />
                ))}
              </div>
              <div>
                {authors.map(({ authorName, authorSlug }, index) => (
                  <React.Fragment key={authorName}>
                    <a
                      style={{}}
                      onClick={() => dataLayerHelper({ event: gtmDataLayer.authorName })}
                      href={renderAuthorLink(authorSlug)}
                      tabIndex="-1"
                    >
                      <AuthorName index={index}>{authorName}</AuthorName>
                    </a>
                    {index === 0 && (
                      <span
                        style={{
                          display: "inline-block",
                          textDecoration: "none",
                          marginLeft: "2px",
                        }}
                      >
                        <span style={{ fontSize: "14px" }}>&amp;</span>
                      </span>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </>
          ) : (
            authors.map(
              ({
                authorName,
                authorSlug,
                profileImage: {
                  file: { url },
                },
              }, index) => (
                <AuthorCard key={authorName}>
                  <AuthorImage index={index} img={`${url}?h=80`} />
                  <a
                    onClick={() =>
                      dataLayerHelper({ event: gtmDataLayer.authorName })
                    }
                    href={renderAuthorLink(authorSlug)}
                    tabIndex="-1"
                  >
                    <AuthorName style={{ textDecoration: "underline" }} index={index}>{authorName}</AuthorName>
                  </a>
                </AuthorCard>
              )
            )
          )}
        </AuthorsContainer>
        {cardType === "small-course-card"
          ? null
          : cardType === "course-card"
            ? generateCourseButtons()
            : generateBonusButtons()}
      </ContentContainer>
    </CardContainer>
  )
}

export default GeneralCard
